import React from 'react';

function Icon() {
  return (
    <svg
      className="guideHomePage__illustrationDots"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 600 600">
      <path
        className="guideHomePage__illustrationLightShade"
        d="M291.01 114.43a3.878 3.878 0 11-7.755 0 3.878 3.878 0 017.755 0z"
      />
      <circle
        cx="333.3"
        cy="429.452"
        r="3.877"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="30.185"
        cy="212.652"
        r="3.877"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="18.554"
        cy="249.486"
        r="1.939"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="179.115"
        cy="360.047"
        r="2.5"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="61.203"
        cy="311.523"
        r="3.877"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="161.646"
        cy="353.272"
        r="3.877"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="268.565"
        cy="108.915"
        r="2.423"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="9.345"
        cy="203.443"
        r="2.423"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="372.038"
        cy="68.21"
        r="2.908"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="382.63"
        cy="80.802"
        r="3.5"
        className="guideHomePage__illustrationLightShade"
      />
      <circle
        cx="367.13"
        cy="82.302"
        r="2"
        className="guideHomePage__illustrationLightShade"
      />
      <circle cx="330.082" cy="412.258" r="4.847" fill="#F2C94C" />
      <circle cx="273.113" cy="125.251" r="4.847" fill="#F2C94C" />
      <circle cx="169.88" cy="377.426" r="4.847" fill="#F2C94C" />
      <circle cx="346.644" cy="418.417" r="3" fill="#F2C94C" />
    </svg>
  );
}

export default Icon;
